<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <router-link to="/dealer/inbox" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <h3>Benachrichtigungsdetails</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="notification-content" v-if="inboxData">
        <div v-if="inboxData.type === 'Statusänderung des Produktes'">
          <span>
            <b>Hallo {{ currentUser.first_name }},</b><br />
            {{ inboxData.message }} </span
          ><br /><br />
          <div v-if="productData.length">
            <img :src="roomImage" alt="" width="200px" />
            <div class="room-data-wrapper">
              <h5>{{ productData.product_name }}</h5>
            </div>
            <span v-if="productData.length"
              ><router-link
                target="_blank"
                :to="'/dealer/edit-product/' + productData.id"
                ><b>Hier klicken</b></router-link
              >
              für Produktdetails</span
            >
            <br /><br />
          </div>
        </div>

        <div v-if="inboxData.type === 'Produkt gelöscht'">
          <span>
            <b>Hallo {{ currentUser.first_name }},</b><br />
            {{ inboxData.message }}
          </span>
        </div>

        <div
          v-if="
            inboxData.type === 'Neues Produkt durch den Administrator angelegt'
          "
        >
          <span>
            <b>Hallo {{ currentUser.first_name }},</b><br />
            {{ inboxData.message }}
          </span>
          <div v-if="productData.length">
            <img :src="roomImage" alt="" width="200px" />
            <div class="room-data-wrapper">
              <h5>{{ productData.product_name }}</h5>
            </div>
            <span v-if="productData.length"
              ><router-link
                target="_blank"
                :to="'/dealer/edit-product/' + productData.id"
                ><b>Hier klicken</b></router-link
              >
              für Produktdetails</span
            >
            <br /><br />
          </div>
        </div>

        <div v-if="inboxData.type == 'Support Antwort'">
          <div>
            <span>
              <b>Hallo {{ currentUser.first_name }},</b><br />
              {{ inboxData.message }}
            </span>
          </div>
          <v-divider></v-divider>
          <h5>Nachricht</h5>
          <div v-html="supportDetails.message"></div>

          <v-btn
            @click="goToSupportReply(inboxData.support_id)"
            class="no-button"
            >Antwort senden</v-btn
          >
        </div>
      </div>
      <div class="text-center" v-else>
        <span>Etwas ist schief gelaufen.</span>
      </div>
    </div>

    <notifications group="inbox" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import Notifications from "vue-notification";
import JwtService from "@/core/services/jwt.service";
import HtmlClass from "@/core/services/htmlclass.service";
import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Loader from "@/components/admin/layout/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import providerAPI from "@/api/provider";
Vue.use(Notifications);
export default {
  name: "Inbox",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.getNotification();
    }
  },
  mounted() {
    //providerAPI.readStatusUpdate({ id: this.$route.params.id });
    providerAPI.readStatusUpdate({ id: [parseInt(this.$route.params.id)] });
  },
  data() {
    return {
      inboxData: [],
      postpones: [],
      users: [],
      userData: [],
      productData: [],
      bookingData: [],
      supportDetails: [],
      roomImage: "",
      searchNameKey: "",
      searchCategoryKey: "",
      loading_inboxData: true,
      categoryName: "Workshop",
      filter: {
        orderCol: "id",
        orderBy: "desc",
      },
      pagination: {
        currentPage: 1,
        perPage: 20,
        paginationRows: "",
      },
      rating: [],
    };
  },
  methods: {
    goToSupportReply(id) {
      let encodedId = btoa(btoa(id))
      this.$router.push({ path: "/dealer/support-response/" + encodedId });
    },
    base64str(id) {
      return btoa(id);
    },
    goToDetails(id) {
      this.$router.push({ path: "/dealer/inbox/" + id });
    },
    paginationChange() {
      this.blogs = [];
      this.loading_inboxData = true;
      setTimeout(() => {
        this.getBlogs();
      }, 100);
    },
    getNotification() {
      providerAPI
        .getNotification({ id: this.$route.params.id })
        .then((response) => {
          if (response.status == "success") {
            this.inboxData = response.data[0];
            if (this.inboxData.type == "Support Antwort") {
              this.supportDetails = this.inboxData.support_detail;
            }
            if (response.data[0].booking) {
              this.bookingData = response.data[0].booking;
            }
            if (response.data[0].users) {
              this.userData = response.data[0].users;
            }
            if (response.data[0].product_detail) {
              this.productData = response.data[0].product_detail;
              this.roomImage =
                response.data[0].product_detail.pictures[0].photo_path;
            }
            if (response.data[0].rating) {
              this.rating = response.data[0].rating;
            }
            this.loading_inboxData = false;
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          } else {
            this.loading_inboxData = false;
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.$notify({
              group: "inbox",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.loading_inboxData = false;
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.$notify({
            group: "inbox",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 5000,
          });
        });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.invite-btn {
  background-color: #3d5a80 !important;
}

.invite-btn:hover {
  background-color: #002c47 !important;
}

.new-btn-text {
  margin-left: 10px;
  font-size: 13px;
}

a {
  cursor: pointer;
}

.file-modal {
  padding: 0;
  margin: 0;
}

.modal-image {
  width: 100%;
}

.table-image {
  cursor: pointer;
  margin: 5px;
}

th {
  cursor: pointer;
}

.loading-tbody {
  text-align: center;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  height: 48px;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 14px;
  height: 48px;
}

.clickable-td {
  cursor: pointer;
}
</style>